import { NgModule } from '@angular/core'
import { CapitalizeModule } from './capitalize/capitalize.module'
import { FuzzySearchModule } from './fuzzy-search/fuzzy-search.module'
import { KeepHtmlModule } from './keep-html/keep-html.module'
import { PluralizeModule } from './pluralize/pluralize.module'
import { SentenceCaseModule } from './sentencecase/sentencecase.module'

const pipes = [
  CapitalizeModule,
  FuzzySearchModule,
  KeepHtmlModule,
  PluralizeModule,
  SentenceCaseModule,
]

@NgModule({
  imports: pipes,
  exports: pipes,
})
export class PipesModule {}
